import React from 'react';
import {Button, Card, TextField} from "@mui/material";

import "../../App.css";
import "./AdminLogin.css";
import {doHttpRequest} from "../../util/NetUtil";

export default function AdminLogin() {

    const [data, setData] = React.useState({
        user: "",
        password: ""
    });

    const handleChange = (obj) => {
        setData({...data, [obj.target.name] : obj.target.value})
    }

    const handleSubmit = () => {
        if (data.user.length > 0 && data.password.length > 0) {

            doHttpRequest(
                "/dashboard/login",
                data,
                response => {
                    if (response.code === 200) {
                        window.location = "/admin-dashboard";
                    } else {
                        alert("Failed to authenticate.  Reason:" + response.body);
                    }
                }, error => {
                    alert("Failed to authenticate. Reason: " + error.message);
                });

        } else {
            alert("You must provide a username and password to continue");
        }
    }

    return (
        <React.Fragment>

            <div style={{
                width: '100%',
                height: '100%',
                minHeight: "100%",
                display: "flow",
                justifyContent: 'center',
                alignContent: 'center',
                textAlign: 'center',
            }}>
                <div style={{
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: "30px",
                    maxWidth: "500px",
                    maxHeight: "300px",
                    width: "100%",
                }}>
                    <Card style={{
                        width: "100%"
                    }}>
                        <div
                            className={"default-font-color-dark"}
                            style={{
                                marginBottom: "20px",
                                marginTop: "10px"
                            }}
                        >
                            Admin Login
                        </div>
                        <div>
                            <TextField
                                name={"user"}
                                label={"User Name"}
                                fullwidth={true}
                                style={{
                                    marginRight: "10px"
                                }}
                                value={data.user}
                                onChange={handleChange}
                            />
                            <TextField
                                style={{
                                    marginLeft: "10px"
                                }}
                                name={"password"}
                                label={"Password"}
                                fullwidth={true}
                                value={data.password}
                                onChange={handleChange}
                                type={"password"}
                            />
                        </div>
                        <div style={{
                            marginTop: "20px",
                            marginBottom: "20px"
                        }}>
                            <Button
                                variant={"contained"}
                                onClick={handleSubmit}
                            >
                                Login
                            </Button>
                        </div>
                    </Card>
                </div>
            </div>

        </React.Fragment>
    )

}